import { Reducer } from "redux";

import {
  ClientBillingAction,
  ClientBillingActionType,
} from "../action/client_billing_action";
import { ClientBillingState } from "../store/client_billing_state";

const initialState: ClientBillingState = {
  company: null,
  isLoading: false,
};

const clientBillingReducer: Reducer<ClientBillingState> = (
  state = initialState,
  action: ClientBillingAction
): ClientBillingState => {
  switch (action.type) {
    case ClientBillingActionType.REQUEST_GET_COMPANY: {
      return Object.assign({}, state, {
        isLoading: true,
      });
    }
    case ClientBillingActionType.CALLBACK_GET_COMPANY: {
      if (action.isSuccess) {
        return Object.assign({}, state, {
          company: action.item ? action.item.company : null,
          planHistories: [],
          isLoading: false,
        });
      } else {
        return Object.assign({}, state, {
          isLoading: false,
        });
      }
    }

    case ClientBillingActionType.REQUEST_CREATE_PAYMENT_INFO: {
      return Object.assign({}, state, {
        isLoading: true,
      });
    }
    case ClientBillingActionType.CALLBACK_CREATE_PAYMENT_INFO: {
      if (action.isSuccess) {
        return Object.assign({}, state, {
          company: action.item ? action.item.company : null,
          isLoading: false,
        });
      } else {
        return Object.assign({}, state, {
          isLoading: false,
        });
      }
    }
    default:
      return state;
  }
};

export default clientBillingReducer;



// WEBPACK FOOTER //
// ./src/presentation/reducer/client_billing_reducer.ts